export default __webpack_public_path__ + "static/media/complementary--except-motorcycles--g1.1c4d4f08.png";